import React, { useEffect, useState } from 'react'
import {
  Button, Card, CardActions, CardContent, CardHeader, Container, CircularProgress,
  Grid, ImageList, ImageListItem, Link, Snackbar, Typography
} from '@material-ui/core'
import {
  AccountCircle, FlagRounded, OutlinedFlagRounded, Share, ShareOutlined, NavigateNext
} from '@material-ui/icons'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { blue, grey } from '@material-ui/core/colors'
// import Identicon from 'identicon.js'
import { useStyles } from '../styles'
import { getLocalDateTime } from '../utils'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'
import UserProfileCard from './UserProfileCard'
import SharersList from './SharersList'
import LikersList from './LikersList'
import ErrorCard from './ErrorCard'
import Dialog from "./Dialog";
import { db } from '../firebase'


function AdPostCard({ id }) {

  const classes = useStyles()
  const {
    curUser, posts, loadPost, viewPost, likePost, unLikePost, sharePost, endPostTime,
    clickButton, purchaseButton,
    clickOnAuthorProfile, clickOnFriendProfile, clickOnSharersList, clickOnLikersList,
  } = useAdDatabase()

  const thisPost = posts[id]

  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [hasRead, setHasRead] = useState(false)
  const [reading, setReading] = useState(false)
  const [liking, setLiking] = useState(false)
  const [sharing, setSharing] = useState(false)
  const [clicking, setClicking] = useState(false)   // hook to track clicking
  const [purchasing, setPurchasing] = useState(false) // hook to track purchase/install
  const [popupOpen, setPopupOpen] = useState(false)
  // const [sharePopupOpen, setSharePopupOpen] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  // const [likedMessage, setLikedMessage] = useState('')
  // const [sharedMessage, setSharedMessage] = useState('')
  // const [anchorEl, setAnchorEl] = useState(null)
  const [userProfile, setUserProfile] = useState({})
  const [likersList, setLikersList] = useState([])
  const [sharersList, setSharersList] = useState([])
  const [sharersListOpen, setSharersListOpen] = useState(false)
  const [likersListOpen, setLikersListOpen] = useState(false)
  const [hasClickedOnAuthor, setHasClickedOnAuthor] = useState(false)
  const [hasClickedOnFriend, setHasClickedOnFriend] = useState(false)
  const [hasClickedOnSharers, setHasClickedOnSharers] = useState(false)
  const [hasClickedOnLikers, setHasClickedOnLikers] = useState(false)


  const handleRefresh = async () => {
    setLoading(true)
    setSubmitting(false)
    setError('')
    setExpanded(false)
    setHasRead(false)
    setReading(false)
    setLiking(false)
    setSharing(false)
    setClicking(false)
    setPurchasing(false)
    setPopupOpen(false)
    setPopupMessage('')
    setUserProfile({})
    setSharersList([])
    setLikersList([])
    setSharersListOpen(false)
    setLikersListOpen(false)
    setHasClickedOnAuthor(false)
    setHasClickedOnFriend(false)
    setHasClickedOnSharers(false)
    setHasClickedOnLikers(false)
    try {
      await loadPost(id)
      setLoading(false)
    } catch (err) {
      setError('Some error occurred. Please try again.')
      setLoading(false)
    }
  }

  const handleLike = () => {
    setLiking(true)
    if (!thisPost.likers.has(curUser.prolificId)) {
      likePost(id).then(_ => {
        setLiking(false)
        setPopupMessage('Post liked successfully.')
        handlePopupOpen()
      }).catch(err => {
        setLiking(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
    } else {
      unLikePost(id).then(_ => {
        setLiking(false)
        setPopupMessage('Like removed.')
        handlePopupOpen()
      }).catch(err => {
        setLiking(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
    }
    // var action = thisPost.likers.has(currentUserData.mturkId) ? 'unlike' : 'like'
    // toggleLikePost(postId, action, friendData)
    //   .then(_ => {
    //     setInitials()
    //     setLiking(false)
    //     if (action === 'like') setLikedMessage('Post liked successfully.')
    //     else if (action === 'unlike') setLikedMessage('Like removed.')
    //     handleLikePopupOpen()
    //   })
    //   .catch(err => {
    //     console.log(err.name, err.message)
    //     setLiking(false)
    //     setLikedMessage('Some error occurred!')
    //     handleLikePopupOpen()
    //   })
  }

  const handleShare = () => {
    setSharing(true)
    // var friendData = matchedFriend.name ? { ...matchedFriend } : {}
    sharePost(id).then(_ => {
        setSharing(false)
        setPopupMessage('Post shared with your friends successfully.')
        handlePopupOpen()
      }).catch(err => {
        setSharing(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
  }

  


  function incrementNumPurchases(curUser) {
    const docRef = db.collection('users').doc(curUser.prolificId);
    docRef.get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          const numPurchases = data.numPurchases || 0;
          const newNumPurchases = numPurchases + 1;
          docRef.update({ numPurchases: newNumPurchases })
            .then(() => {
              console.log('Num purchases updated successfully');
            })
            .catch((error) => {
              console.error('Error updating num purchases:', error);
            });
        } else {
          console.error('User document not found');
        }
      })
      .catch((error) => {
        console.error('Error fetching user document:', error);
      });
  }

  // Write function to handle clicking of the "buy/install now" or "Learn more" button
  const handleClicking = () => {
    setClicking(true)
    // var friendData = matchedFriend.name ? { ...matchedFriend } : {}
    clickButton(id).then(_ => {
        setClicking(false)
      }).catch(err => {
        setClicking(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
  }


  // Write function to handle conversion click (confirming installing/buying/visiting)
  const handlePurchasing = () => {
    setPurchasing(true)
    // var friendData = matchedFriend.name ? { ...matchedFriend } : {}
    
    let fileName;

    if (!thisPost.purchasers.has(curUser.prolificId)){ 
    purchaseButton(id).then(_ => {
        setPurchasing(false)




        if (id === 0){

          fileName = 'TimeBlockPlanner-template.pdf';
  

          //setPopupMessage('App installed!')
        } else if (id === 1){ 

          fileName = 'BringYourPlantsToLife-coloring.pdf';


          //setPopupMessage('Order confirmed!')
        } else if (id === 2){ 

          fileName = 'ChocolateChipCookies-recipe.pdf';


          //setPopupMessage('Website Visited!')
        } else if (id === 3){ 

          fileName = 'HabitTracker-template.pdf';
          

          //setPopupMessage('Order confirmed!')
        } 

        const downloadUrl = process.env.PUBLIC_URL + '/downloads/' + fileName;
  
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        setPopupMessage('Thank you for your purchase! Your download will start automaticlly.')

        incrementNumPurchases(curUser);



        handlePopupOpen()
      }).catch(err => {
        setPurchasing(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
    } else {   // if already installed/purchased, then say so.

        setPurchasing(false)
        setPopupMessage('You alreadly downloaded this product!')
 
        handlePopupOpen()
        


    }
  }








  const handleContinue = async () => {
    setError('')
    setSubmitting(true)
    try {
      await endPostTime(id)
    } catch (err) {
      setError('Some error occurred. Please try again.')
      setSubmitting(false)
    }
  }

  const handlePopupOpen = () => {
    setPopupOpen(true)
  }

  const handlePopupClose = () => {
    setPopupOpen(false)
  }

  const handleUserProfileCardOpen = (clickedOn, userId, name, gender) => {
    if (clickedOn === 'author') {
      if (!hasClickedOnAuthor) {
        setHasClickedOnAuthor(true)
        clickOnAuthorProfile(id).then(_ => {}).catch(err => {setHasClickedOnAuthor(false)})
      }
    }
    else if (clickedOn === 'friend') {
      if (!hasClickedOnFriend) {
        setHasClickedOnFriend(true)
        clickOnFriendProfile(id).then(_ => {}).catch(err => {setHasClickedOnFriend(false)})
      }
    }
    setUserProfile({ userId, name, gender })
  }

  const handleUserProfileCardClose = () => {
    setUserProfile({})
  }

  const handleSharersListOpen = () => {
    if (!hasClickedOnSharers) {
      setHasClickedOnSharers(true)
      clickOnSharersList(id).then(_ => {}).catch(err => {setHasClickedOnSharers(false)})
    }
    setSharersList(_ => {
      let list = thisPost.initialSharers.map(name => ({ name: name, id: name }))
      if (thisPost.sharers.has(curUser.prolificId))
        list.unshift({ name: `${curUser.name} (you)`, id: curUser.prolificId })
      if (thisPost.friendData.type === 'shared')
        list.unshift({ name: thisPost.friendData.name, id: thisPost.friendData.id })
      return list
    })
    setSharersListOpen(true)
  }

  const handleSharersListClose = () => {
    setSharersListOpen(false)
    setSharersList([])
  }

  const handleLikersListOpen = () => {
    if (!hasClickedOnLikers) {
      setHasClickedOnLikers(true)
      clickOnLikersList(id).then(_ => {}).catch(err => {setHasClickedOnLikers(false)})
    }
    setLikersList(_ => {
      let list = thisPost.initialLikers.map(name => ({ name: name, id: name }))
      if (thisPost.likers.has(curUser.prolificId))
        list.unshift({ name: `${curUser.name} (you)`, id: curUser.prolificId })
      if (thisPost.friendData.length > 0){ // if some friend likes the post

        //let friends_who_like = thisPost.friendData.map((this_friend) =>(name: this_friend, id: this_friend) )

        for (const a_friend of thisPost.friendData){ // this should be iteration by value

          list.unshift({ name: a_friend, id: a_friend })
        }
      }
      return list
    })
    setLikersListOpen(true)
  }

  const handleLikersListClose = () => {
    setLikersListOpen(false)
    setLikersList([])
  }

  const handleExpand = () => {
    if (hasRead) {
      setExpanded(true)
    }
    else {
      if (!reading) {
        setReading(true)
        viewPost(id).then(_ => {
          setReading(false)
          setExpanded(true)
          setHasRead(true)
        }).catch(err => {
          setReading(false)
        })
      }
    }
  }

  const handleCollapse = () => {
    setExpanded(false)
  }

  useEffect(() => {
    handleRefresh()
    //eslint-disable-next-line
  }, [id])

  return (
    <div className='postCard' style={{ marginBottom: '90px' }}>
      <Container maxWidth='md'>
        {loading ?
          <div style={{ textAlign: 'center' }}>
            <CircularProgress color='secondary' />
          </div> :
          error ?
            <ErrorCard message={error} action={handleRefresh} /> :
            thisPost ?
            <>
              <Card elevation={2} className={classes.postCard}>

                <CardActions>
                  <Grid container spacing={1} justifyContent='flex-end'
                    style={{ borderBottom: 'solid 1px #ccc', padding: '2px 4px 0px' }}
                  >
                    {/* {thisPost.friendData.name &&
                        <Grid item xs>
                          <Typography variant='subtitle1'>
                            <strong>
                              <Typography variant='inherit'
                                onClick={_ => {
                                  handleUserProfileCardOpen('friend', thisPost.friendData.id, thisPost.friendData.name)
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {thisPost.friendData.name}
                              </Typography>
                            </strong>
                            {' ' + thisPost.friendData.type + ' this'}
                          </Typography>
                        </Grid>
                    } */}



                    <Grid item>
                      {(thisPost.friendData.length + thisPost.initialLikers.length > 0)?(
                      <ThumbUpAltOutlinedIcon className={classes.postCardIcon} style={{ color: blue[700], cursor: 'pointer' }} onClick={handleLikersListOpen} />
                      ):<></>}
                    </Grid>
                    <Grid item>
                      <Typography variant='body1'>
                        <strong>
                          {(thisPost.friendData.length > 0) &&
                            <>

                          

                        
                              <Typography variant='inherit' style={{ cursor: 'pointer' }}
                              onClick={handleLikersListOpen}>
                                
                                {thisPost.friendData.join(', ')}


                              </Typography>
                              <Typography variant='inherit'>
                                {(thisPost.initialLikers.length > 0) ? ' and ' : ' liked this'}
                              </Typography>
                            </>

                            
                          }
                          <Typography variant='inherit' style={{ cursor: 'pointer' }} onClick={handleLikersListOpen}>
                            { (thisPost.initialLikers.length > 0) ? (
                            
                                thisPost.initialLikers.length
                                + ((thisPost.friendData.length > 0) ? ' others' : ' people')
                                + ' liked this'

                             ):

                                  ''

                              
                            }
                          </Typography>
                        </strong>
                      </Typography>
                      {/* <Typography variant='subtitle1' style={{ cursor: 'pointer' }} onClick={handleLikersListOpen}>
                        <strong>
                          {
                            (thisPost.initialLikers.length + (thisPost.friendData.type === 'liked') + thisPost.likers.has(curUser.mturkId))
                            + ' like'
                            + ((thisPost.initialLikers.length + (thisPost.friendData.type === 'liked') + thisPost.likers.has(curUser.mturkId)) > 1 ? 's' : '')
                          }
                        </strong>
                      </Typography> */}
                    </Grid>

                    
                  </Grid>
                </CardActions>

                <CardHeader
                  avatar={
                    // <img alt='account-avatar' className={classes.avatar}
                    //   src={`data:image/png;base64,${new Identicon(thisPost.authorData.id, 40).toString()}`}
                    // />
                    <AccountCircle style={{ color: grey[500], fontSize: 40 }} />
                  }
                  title={
                    <Typography variant='subtitle1'>
                      {thisPost.type === 'shared' && 'Shared by '}
                      <Typography variant='inherit' color='primary'
                        onClick={_ => {
                          handleUserProfileCardOpen('author', thisPost.authorData.id, thisPost.authorData.name)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {thisPost.authorData.name}
                      </Typography>
                    </Typography>
                  }
      
                  subheader={
                    <Typography variant='caption' color='textSecondary'>
                    {thisPost.is_ad==="Y"
                    ? 'Sponsored'
                    : thisPost.post_subtitle
                    }
                    </Typography>
                  }
                />

                <CardContent>

                  {/* {thisPost.type === 'shared' &&
                    <Typography variant='body2' color='textSecondary' paragraph>
                      <Link component={RouterLink} to={`/post/${thisPost.orgPostId}`}>
                        View original post
                      </Link>
                      {' by '}
                      <Link component={RouterLink} to={`/user/${refPost.creator}`}>
                        {orgAuthorName}
                      </Link>
                    </Typography>
                  } */}

                  <Typography variant='body1' className={classes.paragraph} paragraph>
                    {thisPost.content}
                  </Typography>

                  {thisPost.attachments.length ?
                    <ImageList cols={1} rowHeight={250} className={classes.postCardImageList}>
                      {thisPost.attachments.map(a => (
                        <ImageListItem key={a.url} component={Link}
                          href={a.url} target='_blank'
                        >
                          <img src={a.url} alt='' style={{ objectFit: 'contain', height: 250 }} />
                        </ImageListItem>
                      ))}
                    </ImageList> :
                    <></>
                  }

                </CardContent>

                <CardActions>
                  <Grid container spacing={2} alignItems='right'>
                  <Grid xs={8}>
                      <div></div>
                  </Grid>


                    <Grid>

                     <div className="App">
                        <Dialog
                          render={({ close, labelId, descriptionId }) => (
                            <>
                              <h3 id={labelId}> {thisPost.product_install_message}</h3>
                              <ImageList cols={1} rowHeight={250} className={classes.postCardImageList}>
                                {thisPost.attachments.map(a => (
                                  <ImageListItem key={a.url} component={Link}
                                    href={a.url} target='_blank'
                                  >
                                    <img src={a.url} alt='' style={{ objectFit: 'contain', height: 250 }} />
                                  </ImageListItem>
                                ))}
                              </ImageList> 
                              <p id={descriptionId}>
                                {thisPost.popup_description}
                              </p>
                              <button class='my-button-small-bold' onClick={() => {handlePurchasing(); close()}}>{thisPost.popup_button_text}</button>
                              <button class='my-button-small' onClick={close}>Cancel</button>

                            </>
                          )}
                        >
                          
                          <Grid xs={4}>
                            
                           {
                            thisPost.is_buynow_message==="Y"
                            ? <button class='my-button' onClick={handleClicking} >{thisPost.button_message.Y}</button>
                            : <button class='my-button' onClick={handleClicking} >{thisPost.button_message.N}</button>
                           }
                              
                           

                          </Grid>
                        </Dialog>
                      </div>
                    </Grid>


                  </Grid>
                </CardActions>


                <CardActions>
                  <Grid container spacing={2} alignItems='center' style={{ borderTop: '1px solid #ccc' }}>
                    <Grid item xs>
                      <Button disabled={liking} onClick={handleLike} fullWidth style={{ textTransform: 'none' }}>
                        {thisPost.likers.has(curUser.prolificId) ?
                          <>
                            <ThumbUpOffAltIcon fontSize='large' style={{ color: blue[700] }} className={classes.postCardIcon} />
                            <Typography variant='button'>Un-like</Typography>
                          </> :
                          <>
                            <ThumbUpAltOutlinedIcon fontSize='large' style={{ color: blue[700] }} className={classes.postCardIcon} />
                            <Typography variant='button'>Like</Typography>
                          </>
                        }
                      </Button>
                    </Grid>
         
                    <Grid item xs>
                      <Button disabled={submitting} onClick={handleContinue} fullWidth style={{ textTransform: 'none' }}>
                        <Typography variant='button'>Continue</Typography>
                        <NavigateNext fontSize='large' style={{ color: blue[700] }} />
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>





              </Card>

              {/* <ContinueCard action={handleContinue} disable={loading || liking || sharing || reading || submitting} /> */}

              <Snackbar
                open={popupOpen}
                message={popupMessage}
                onClose={handlePopupClose}
                autoHideDuration={6000}
              />

              <UserProfileCard open={Boolean(userProfile.name)} userProfile={userProfile} handleClose={handleUserProfileCardClose} />
              <SharersList open={sharersListOpen} list={sharersList} handleClose={handleSharersListClose} />
              <LikersList open={likersListOpen} list={likersList} handleClose={handleLikersListClose} />
            </>
            : <></>
        }
    </Container>
    </div>
  )
}

export default AdPostCard
